import React from 'react';

const CharlieMarshNotionArticle = () => {
  return (
    <article id="block-6d52b13d76774644b6424d22b79d7ea1" className="notion-root max-width has-footer">
      <p id="block-d16f6052f7f2490d84d90e313df30d1a" className="notion-text notion-text__content notion-semantic-string">
        Hi, I'm <a href="https://www.crmarsh.com/" className="notion-link link" target="_blank" rel="noopener noreferrer">Charlie Marsh</a>.
      </p>
      <div id="block-faa963b710ea4dd7ad3ddd8b9c7f0735" className="notion-text"></div>
     
      <p id="block-14d8a36b9fe8467d9f7a4877ef596fdc" className="notion-text notion-text__content notion-semantic-string">
        I'm building high-performance developer tools for Python, starting with <a href="https://github.com/charliermarsh/ruff" className="notion-link link" target="_blank" rel="noopener noreferrer">Ruff</a>, an extremely fast Python linter written in Rust.
      </p>

      <div id="block-4e8cb5d4688b44f3a5b76f567d06650a" className="notion-text"></div>
      <p id="block-09e4ccc0bcbf43f98e5991be767e4fd8" className="notion-text notion-text__content notion-semantic-string">
        I was most recently a staff software engineer at <a href="https://www.springdiscovery.com/" className="notion-link link" target="_blank" rel="noopener noreferrer">Spring Discovery</a>. Before that, I was a senior software engineer at <a href="https://www.khanacademy.org/" className="notion-link link" target="_blank" rel="noopener noreferrer">Khan Academy</a>.
      </p>
      <div id="block-a8de7fd07b2b476fa13f9c7b5655566e" className="notion-text"></div>
      <p id="block-3e79c0b321a94f82b834418b2c840a5a" className="notion-text notion-text__content notion-semantic-string">
        This is a collection of notes and blog posts I’ve written on Notion:
      </p>
       <li>
          <a id="block-using-mypy-in-production-at-spring" className="notion-link notion-page emoji" href="https://notes.crmarsh.com/using-mypy-in-production-at-spring">
            <span className="notion-page__icon">
              <span className="notion-icon text" style={{ width: '20px', height: '20px', fontSize: '20px', fill: 'var(--color-text-default-light)' }}>🐍</span>
            </span>
            <span className="notion-page__title notion-semantic-string">Using Mypy in production at Spring</span>
          </a>
       </li>
        <li>
        <a id="block-whats-webassembly" className="notion-link notion-page emoji" href="https://notes.crmarsh.com/whats-webassembly">
                <span className="notion-page__icon">
                  <span className="notion-icon text" style={{ width: '20px', height: '20px', fontSize: '20px', fill: 'var(--color-text-default-light)' }}>🌐</span>
                </span>
                <span className="notion-page__title notion-semantic-string">What’s WebAssembly?</span>
              </a>
        </li>
        <li>
        <a id="block-python-tooling-could-be-much-much-faster" className="notion-link notion-page emoji" href="https://notes.crmarsh.com/python-tooling-could-be-much-much-faster">
                <span className="notion-page__icon">
                  <span className="notion-icon text" style={{ width: '20px', height: '20px', fontSize: '20px', fill: 'var(--color-text-default-light)' }}>🛠️</span>
                </span>
                <span className="notion-page__title notion-semantic-string">Python tooling could be much, much faster</span>
              </a>
        </li>
        <li>
        <a id="block-building-large-language-model-powered-applications" className="notion-link notion-page emoji" href="https://notes.crmarsh.com/building-large-language-model-powered-applications">
                <span className="notion-page__icon">
                  <span className="notion-icon text" style={{ width: '20px', height: '20px', fontSize: '20px', fill: 'var(--color-text-default-light)' }}>🤖</span>
                </span>
                <span className="notion-page__title notion-semantic-string">Building large language model-powered applications</span>
              </a>
        </li>
        <li>
        <a id="block-isolates-microvms-and-webassembly" className="notion-link notion-page emoji" href="https://notes.crmarsh.com/isolates-microvms-and-webassembly">
                <span className="notion-page__icon">
                  <span className="notion-icon text" style={{ width: '20px', height: '20px', fontSize: '20px', fill: 'var(--color-text-default-light)' }}>☁️</span>
                </span>
                <span className="notion-page__title notion-semantic-string">Isolates, microVMs, and WebAssembly</span>
              </a>
        </li>
        <li>
        <a id="block-ruff-the-first-200-releases" className="notion-link notion-page emoji" href="https://notes.crmarsh.com/ruff-the-first-200-releases">
                <span className="notion-page__icon">
                  <span className="notion-icon text" style={{ width: '20px', height: '20px', fontSize: '20px', fill: 'var(--color-text-default-light)' }}>⚡</span>
                </span>
                <span className="notion-page__title notion-semantic-string">Ruff: The First 200 Releases</span>
              </a>
        </li>

      <div id="block-6794a992cb584bb8b74aa9ff339b404f" className="notion-text"></div>
      <p id="block-9fb5f04bf7274d309fb92d0001cf2e36" className="notion-text notion-text__content notion-semantic-string">
        You can find me on <a href="https://twitter.com/charliermarsh" className="notion-link link" target="_blank" rel="noopener noreferrer">Twitter</a>.
      </p>
      <div id="block-3e5145177df04491ad1646c446e029af" className="notion-text"></div>
      <p id="block-4dbb17370d7a42cf8a5f9114b0f62494" className="notion-text notion-text__content notion-semantic-string">
        For older posts and projects, check out my <a href="https://www.crmarsh.com/" className="notion-link link" target="_blank" rel="noopener noreferrer">personal site</a>.
      </p>
      <div id="block-6b7e97965ac9469791dfdc655481fbca" className="notion-text"></div>
    </article>
  );
};

export default CharlieMarshNotionArticle;
